// @flow

import axios from "axios";
import { EXTERNAL_CONNECTION_ERRORS } from "./constants";

export type AppRecordRequest = {
  key: string
};

const getInteractivesS3Records = async ({
  key
}: AppRecordRequest) => { 
  try {
    // Ensure all required parameters are included, making catching errors early a priority.
    const required = [
     key
    ];
    if (required.indexOf(undefined) > -1) {
      throw new Error(
        "One or more of the details to required to save this application record was not provided."
      );
    }

    // Attempt to get the application record
    const appRecordData = {
      key
    };
    const retAppRecord = await axios.post(
      "/api/shared/get-interactives-s3-records",
      appRecordData
    );
    return retAppRecord;
  } catch (error) {
    console.error("Utils - Get interactives s3 records - Error:", error);
    throw new Error(EXTERNAL_CONNECTION_ERRORS.SAVE_RECORD);
  }
};

export default getInteractivesS3Records;
